export default __webpack_public_path__ + "static/media/OpenSans-ExtraBoldItalic.87a229e6.woff";